import { LetteratiQuiz, LetteratiQuestion } from "./QuizModel";

export class LetteratiGameData{

    rawData:any;

    quiz: LetteratiQuiz|null = null;

    constructor(rawData:any,fullScorePerQuestion:number,maxLife:number,practiceMode:boolean,timeLimitPerQuestion:number,timeLimitPerLetter:number){
        this.rawData = rawData;
        this.parse(this.rawData,fullScorePerQuestion,maxLife,practiceMode,timeLimitPerQuestion,timeLimitPerLetter);
    }

    //TODO: Add Null Checks
    parse(gameData:any,fullScorePerQuestion:number,maxLife:number,practiceMode:boolean,timeLimitPerQuestion:number|null,timeLimitPerLetter:number):void{
        let questions:Array<LetteratiQuestion> = [];
        for (let index = 0; index < gameData.questions.length; index++) {
            const element = gameData.questions[index];
            let question: LetteratiQuestion = new LetteratiQuestion(element.id,element.question,element.answer,20);
                questions.push(question);
        }
        this.quiz = new LetteratiQuiz(questions,fullScorePerQuestion,maxLife,practiceMode,timeLimitPerQuestion,timeLimitPerLetter);
    }

    createRandomQuiz(questionCount:number,practiceMode?:boolean,fullScorePerQuestion?:number,maxLife?:number,timeLimitPerQuestion?:number|null,timeLimitPerLetter?:number):LetteratiQuiz{
        let questionCountTarget = Math.min(questionCount, this.quiz ? this.quiz.questions.length : questionCount);
        let randomQuestionIndexes = Phaser.Utils.Array.NumberArray(0,this.quiz!.questions.length-1);
        Phaser.Utils.Array.Shuffle(randomQuestionIndexes);
        let randomQuestions:LetteratiQuestion[] = [];
        for (let index = 0; index < questionCountTarget; index++) {
            const element = this.quiz ? this.quiz.questions[randomQuestionIndexes[index]]: null;
            if(element){
                randomQuestions.push(element);
            }
        }
        let _fullScorePerQuestion  = fullScorePerQuestion ? fullScorePerQuestion : (this.quiz ? (this.quiz.fullScorePerQuestion ? this.quiz.fullScorePerQuestion : 50) : 50);
        let _maxLife  = maxLife ? maxLife : (this.quiz ? (this.quiz.maxLife ? this.quiz.maxLife : 3) : 3);
        let _practiceMode = practiceMode ? practiceMode : (this.quiz ? (this.quiz.practiceMode ? this.quiz.practiceMode : false) : false);
        let _timeLimitPerQuestion = timeLimitPerQuestion ? timeLimitPerQuestion : (this.quiz ? (this.quiz.timeLimitPerQuestion ? this.quiz.timeLimitPerQuestion : null) : null);
        let _timeLimitPerLetter = timeLimitPerLetter ? timeLimitPerLetter : 5;
        let result = new LetteratiQuiz(randomQuestions,_fullScorePerQuestion,_maxLife,_practiceMode,_timeLimitPerQuestion,_timeLimitPerLetter);
        return result;
    }

}